const getTipoDocumentoFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'formato_regex', label: 'Formato' },
];

export default getTipoDocumentoFilterFields;
